export default __webpack_public_path__ + "static/media/fileArchive.9c31a1a6.svg";